export const RARITY = {
  common: { label: "COMMON", color: "#9aa3ab", odds: "55%" },
  rare: { label: "RARE", color: "#00c8ff", odds: "32%" },
  legendary: { label: "LEGENDARY WASTELAND EDITION", color: "#ff9900", odds: "13%" },
};

export const DOLOPALS = [
  {
    id: "bruin",
    name: "DJ BRUIN-100",
    title: "The Boombox Bear",
    rarity: "legendary",
    trait: "BRUTE",
    art: "/assets/pals/pal-bruin.png",
    stats: { HUGS: 100, BRAVERY: 92, BEATS: 99, SMARTS: 61 },
    bio: "A giant robo-bear who found Dolo's spare boombox in the ash and decided the apocalypse needed a soundtrack. His scarf is a battle flag, his mixtape is bigger on the inside, and the 100 on his chest counts hugs per day. He is very behind on his hug quota — help him.",
  },
  {
    id: "riff",
    name: "RIFF",
    title: "The Road Bard",
    rarity: "rare",
    trait: "CHARM",
    art: "/assets/pals/pal-riff.png",
    stats: { HUGS: 54, BRAVERY: 77, BEATS: 95, SMARTS: 70 },
    bio: "A wandering bot-bard who bolted a trumpet to a keyboard and called it dinner music. Riff serenades sandstorms until they get shy and calm down. The hat? Found it. The attitude? Factory installed. Never skip his encore.",
  },
  {
    id: "mia",
    name: "MAINFRAME MIA",
    title: "The Signal Witch",
    rarity: "rare",
    trait: "SIGNAL",
    art: "/assets/pals/pal-mia.png",
    stats: { HUGS: 48, BRAVERY: 84, BEATS: 66, SMARTS: 99 },
    bio: "Half kid, half Wi-Fi. Mia talks to the old machines and — weirdly — they listen. Her backpack computer runs on crackers and curiosity, and she once grounded a lightning storm for being too loud. Do not touch the cables. Seriously.",
  },
  {
    id: "socket",
    name: "SOCKET",
    title: "The Scav Kid",
    rarity: "common",
    trait: "SCAVENGE",
    art: "/assets/pals/pal-socket.png",
    stats: { HUGS: 71, BRAVERY: 68, BEATS: 45, SMARTS: 88 },
    bio: "The wasteland's youngest mechanic. Fixed the east gate with a crayon, a wrench, and pure stubbornness. Keeps spare bolts in his lunchbox — right next to the snacks. If it rattles, he can fix it. If it bites, he can probably still fix it.",
  },
  {
    id: "blackout",
    name: "BLACKOUT",
    title: "The Stage-Wrecker",
    rarity: "legendary",
    trait: "BRUTE",
    art: "/assets/pals/pal-blackout.png",
    stats: { HUGS: 12, BRAVERY: 100, BEATS: 88, SMARTS: 74 },
    bio: "Every wasteland band tells the story: the lights die, the crowd goes quiet, and a cape unfolds out of the dark. Blackout doesn't hate music — he hates BAD music, and he can hear a wrong note from three dunes away. The guitars at his feet? They knew what they did. His visor has one button. It has never been pressed. Nobody wants to know.",
  },
  {
    id: "killswitch",
    name: "KILLSWITCH",
    title: "The Red-Eyed Warden",
    rarity: "rare",
    trait: "SIGNAL",
    art: "/assets/pals/pal-killswitch.png",
    stats: { HUGS: 30, BRAVERY: 90, BEATS: 58, SMARTS: 85 },
    bio: "Killswitch guards the last working server farm in the wastes, and he takes the job VERY seriously. Ask nicely and the red eye blinks green: come in, the Wi-Fi is terrible but it's ours. Ask rudely and, well. The wing-capes aren't decorative. They aren't aerodynamic either, but they ARE extremely dramatic.",
  },
  {
    id: "woofer",
    name: "WOOFER",
    title: "The Gramophone Ronin",
    rarity: "rare",
    trait: "CHARM",
    art: "/assets/pals/pal-woofer.png",
    stats: { HUGS: 96, BRAVERY: 81, BEATS: 100, SMARTS: 66 },
    bio: "A good boy from a forgotten age. Woofer's horn catches radio ghosts — songs from before the ash — and plays them through the boombox shrine he refuses to stop standing on. He duels with honor, naps with dedication, and once sat so politely during a siege that both sides stopped to pet him. The siege ended early.",
  },
  {
    id: "kernel",
    name: "KERNEL",
    title: "The Straw-Hat Ronin",
    rarity: "common",
    trait: "SCAVENGE",
    art: "/assets/pals/pal-kernel.png",
    stats: { HUGS: 55, BRAVERY: 86, BEATS: 42, SMARTS: 91 },
    bio: "Kernel walked out of the flooded server valleys with a hat, a katana, and absolutely no explanation. His chest screen still runs harvest forecasts for farms that aren't there anymore. He trades repair work for rice, remembers every road he's ever walked, and answers every question with exactly one nod.",
  },
  {
    id: "slurp",
    name: "SLURP-2355",
    title: "The Coolant Kid",
    rarity: "common",
    trait: "CHARM",
    art: "/assets/pals/pal-slurp.png",
    stats: { HUGS: 78, BRAVERY: 40, BEATS: 71, SMARTS: 58 },
    bio: "Unit 2355 was built for heavy lifting. Unit 2355 discovered pink coolant fizz and immediately retired. Now he sits on his crate, sipping the good stuff, dispensing wisdom like 'stay hydrated' and 'crates are chairs if you believe.' The other titans agree: he has never been wrong, and he has never, ever been in a hurry.",
  },
];

export const COMING_SOON = [
  { id: "soon-1", label: "SERIES 02 // SIGNAL ENCRYPTED" },
  { id: "soon-2", label: "SERIES 02 // SIGNAL ENCRYPTED" },
];

export const CRITTERS = [
  { id: "rust-puppy", name: "RUST PUPPY", color: "#ff9900", shape: "pup" },
  { id: "gear-mouse", name: "GEAR MOUSE", color: "#9aa3ab", shape: "mouse" },
  { id: "static-ferret", name: "STATIC FERRET", color: "#6ee7ff", shape: "ferret" },
  { id: "bolt-toad", name: "BOLT TOAD", color: "#3dff7a", shape: "toad" },
  { id: "signal-moth", name: "SIGNAL MOTH", color: "#ff9df5", shape: "moth" },
  { id: "copper-crab", name: "COPPER CRAB", color: "#d98a4b", shape: "crab" },
  { id: "ash-gecko", name: "ASH GECKO", color: "#b8c4cc", shape: "gecko" },
  { id: "wire-snake", name: "WIRE SNAKE", color: "#ffd23d", shape: "snake" },
  { id: "dust-bunny", name: "DUST BUNNY", color: "#e8e6e3", shape: "bunny" },
  { id: "tube-worm", name: "TUBE WORM", color: "#ff5c7a", shape: "worm" },
  { id: "echo-bat", name: "ECHO BAT", color: "#a78bff", shape: "bat" },
  { id: "spark-snail", name: "SPARK SNAIL", color: "#7ef0c8", shape: "snail" },
  { id: "cinder-newt", name: "CINDER NEWT", color: "#ff6b35", shape: "gecko" },
  { id: "gasmask-gull", name: "GASMASK GULL", color: "#cfd8dc", shape: "gull" },
  { id: "pipe-viper", name: "PIPE VIPER", color: "#8be04e", shape: "snake" },
  { id: "smog-cricket", name: "SMOG CRICKET", color: "#9ec9a8", shape: "beetle" },
  { id: "barb-hound", name: "BARB HOUND", color: "#c98a5e", shape: "pup" },
  { id: "tar-snail", name: "TAR SNAIL", color: "#5c666e", shape: "snail" },
  { id: "fuse-weasel", name: "FUSE WEASEL", color: "#ffb3c1", shape: "ferret" },
  { id: "glow-grub", name: "GLOW GRUB", color: "#d4ff4d", shape: "worm" },
  { id: "static-hare", name: "STATIC HARE", color: "#b3e5ff", shape: "bunny" },
  { id: "ember-crow", name: "EMBER CROW", color: "#ff8a65", shape: "gull" },
  { id: "rust-scorpion", name: "RUST SCORPION", color: "#bf6b4a", shape: "crab" },
  { id: "volt-vole", name: "VOLT VOLE", color: "#fff176", shape: "mouse" },
  { id: "ash-mole", name: "ASH MOLE", color: "#8d9299", shape: "blob" },
  { id: "chrome-cicada", name: "CHROME CICADA", color: "#a5f2e7", shape: "beetle" },
  { id: "sewer-sprite", name: "SEWER SPRITE", color: "#69f0ae", shape: "blob" },
  { id: "cactus-hog", name: "CACTUS HOG", color: "#81c784", shape: "blob" },
  { id: "gravel-turtle", name: "GRAVEL TURTLE", color: "#a1887f", shape: "snail" },
  { id: "neon-newt", name: "NEON NEWT", color: "#18ffff", shape: "gecko" },
  { id: "circuit-centipede", name: "CIRCUIT CENTIPEDE", color: "#4dd0e1", shape: "worm" },
  { id: "oil-otter", name: "OIL OTTER", color: "#90a4ae", shape: "ferret" },
  { id: "sparkplug-pug", name: "SPARK-PLUG PUG", color: "#ffab91", shape: "pup" },
  { id: "rust-raven", name: "RUST RAVEN", color: "#b0bec5", shape: "gull" },
  { id: "static-shrew", name: "STATIC SHREW", color: "#d1c4e9", shape: "mouse" },
  { id: "battery-beetle", name: "BATTERY BEETLE", color: "#c0ca33", shape: "beetle" },
  { id: "fog-frog", name: "FOG FROG", color: "#a5d6a7", shape: "toad" },
  { id: "copper-cobra", name: "COPPER COBRA", color: "#e6a57e", shape: "snake" },
  { id: "dust-moth", name: "DUST MOTH", color: "#e0d7c6", shape: "moth" },
  { id: "rubble-rat", name: "RUBBLE RAT", color: "#9e9e9e", shape: "mouse" },
  { id: "siren-squid", name: "SIREN SQUID", color: "#f48fb1", shape: "ray" },
  { id: "trench-termite", name: "TRENCH TERMITE", color: "#d7ccc8", shape: "beetle" },
  { id: "vapor-viper", name: "VAPOR VIPER", color: "#b2dfdb", shape: "snake" },
  { id: "clank-cricket", name: "CLANK CRICKET", color: "#c5e1a5", shape: "beetle" },
  { id: "ember-ant", name: "EMBER ANT", color: "#ff7043", shape: "beetle" },
  { id: "static-starfish", name: "STATIC STARFISH", color: "#fff59d", shape: "star" },
  { id: "wire-wisp", name: "WIRE WISP", color: "#b39ddb", shape: "blob" },
  { id: "radar-ray", name: "RADAR RAY", color: "#80deea", shape: "ray" },
  { id: "gravel-grub", name: "GRAVEL GRUB", color: "#d7b899", shape: "worm" },
  { id: "echo-eel", name: "ECHO EEL", color: "#82eec9", shape: "snake" },
];

export const SHOP_ITEMS = [
  { id: "frame-crimson", kind: "frame", name: "CRIMSON FRAME", cost: 40, color: "#ff0033", desc: "Blood-red card frame. For titans who bite first." },
  { id: "frame-cyan", kind: "frame", name: "STATIC CYAN FRAME", cost: 60, color: "#00c8ff", desc: "Broadcast-static frame. Hums when storms roll in." },
  { id: "frame-gold", kind: "frame", name: "WASTELAND GOLD FRAME", cost: 100, color: "#ffcf5c", desc: "24-karat scrap. The frame barons approve." },
  { id: "frame-toxic", kind: "frame", name: "TOXIC GREEN FRAME", cost: 150, color: "#3dff7a", desc: "Recovered from the glow pits. Do not lick." },
  { id: "banner-neon", kind: "banner", name: "NEON BANNER GLOW", cost: 80, color: "#ff9900", desc: "Your page banner burns like a midnight sign." },
  { id: "banner-rusted", kind: "banner", name: "RUSTED BANNER FRAME", cost: 60, color: "#ff0033", desc: "Double-forged crimson border, battle-worn finish." },
  { id: "daub-midnight", kind: "daub", name: "MIDNIGHT RELAY INK", cost: 45, color: "#2b4bd8", desc: "Bingo dauber ink — deep broadcast blue, siphoned from the night relays." },
  { id: "daub-toxic", kind: "daub", name: "GLOW PIT INK", cost: 45, color: "#2f9e44", desc: "Bingo dauber ink — reactor-pit green. Slightly warm to the touch." },
  { id: "daub-violet", kind: "daub", name: "ROYAL STATIC INK", cost: 60, color: "#7040c0", desc: "Bingo dauber ink — violet static reserved for callers of distinction." },
  { id: "daub-gold", kind: "daub", name: "BARON'S GOLD INK", cost: 80, color: "#c98a08", desc: "Bingo dauber ink — 24-karat scrap gold. Daub like a frame baron." },
  { id: "daub-bone", kind: "daub", name: "BONE MARROW INK", cost: 80, color: "#efe8d2", desc: "Bingo dauber ink — pale bone white, ground from the old world's chalk." },
  { id: "stamp-star", kind: "stamp", name: "FALLSTAR STAMP", cost: 55, color: "#a8241a", desc: "Bingo daub shape — mark every call with the star that fell on Sector 9." },
  { id: "stamp-diamond", kind: "stamp", name: "DIAMONDBACK STAMP", cost: 55, color: "#a8241a", desc: "Bingo daub shape — a sharp diamondback brand for tidy survivors." },
  { id: "stamp-splat", kind: "stamp", name: "MUD SPLAT STAMP", cost: 70, color: "#a8241a", desc: "Bingo daub shape — slaps ink like acid rain on a tin roof." },
  { id: "stamp-cross", kind: "stamp", name: "RED-X WARRANT STAMP", cost: 70, color: "#a8241a", desc: "Bingo daub shape — the compliance office's favorite mark. X marks the called." },
  { id: "upgrade-wider-dish", kind: "upgrade", name: "WIDER DISH", cost: 60, color: "#ffcf5c", desc: "Radar upgrade — signal spikes linger much longer before they fade. Tap at leisure." },
  { id: "upgrade-worm-repellent", kind: "upgrade", name: "WORM REPELLENT", cost: 80, color: "#ff3b30", desc: "Radar upgrade — worm contacts crawl 40% slower toward your runners." },
  { id: "upgrade-combo-shield", kind: "upgrade", name: "COMBO SHIELD", cost: 50, color: "#00c8ff", desc: "Radar upgrade — one faded spike per chain won't break your combo." },
  { id: "skin-cyan", kind: "skin", name: "STATIC CYAN GRID", cost: 120, color: "#00c8ff", desc: "Radar skin — rewire the tracker to cold broadcast cyan." },
  { id: "skin-pink", kind: "skin", name: "CANDY PINK GRID", cost: 120, color: "#ff5cd8", desc: "Radar skin — bubblegum phosphor for sweet-tooth scouts." },
  { id: "skin-amber", kind: "skin", name: "AMBER RUST GRID", cost: 120, color: "#ff9900", desc: "Radar skin — rustbelt amber, tuned to the old trucker bands." },
];

export const LORE_PAGES = [
  {
    id: "lore-bruin",
    unlockAt: 1,
    title: "THE DAY THE BOOMBOX CHOSE BRUIN",
    pal: "DJ BRUIN-100",
    text: "Nobody leaves a boombox in the ash — that's wasteland law. But there it was, humming under a pile of hubcaps, playing a song nobody remembered recording. Bruin picked it up to return it and the volume knob spun itself to MAX. The boombox had chosen. Now they travel together: the bear carries the beats, and the beats carry the bear. The hubcaps never reported a theft. Hubcaps are cool like that.",
  },
  {
    id: "lore-riff",
    unlockAt: 2,
    title: "RIFF AND THE SHY SANDSTORM",
    pal: "RIFF",
    text: "The big sandstorm of '59 wasn't defeated — it was embarrassed. Riff stood on a dune and played a trumpet-keytar solo so gentle that the storm slowed down to listen, then blushed itself into a light breeze. Weather reports now include a small note: 'conditions may be serenaded.' Riff charges one snack per storm. The storms keep coming back. So do the snacks.",
  },
  {
    id: "lore-mia",
    unlockAt: 3,
    title: "MIA GROUNDS THE LIGHTNING",
    pal: "MAINFRAME MIA",
    text: "A lightning storm once crackled too close to the rescue-kitten shelter, so Mia did what nobody thought to do: she scolded it. 'INSIDE VOLTAGE,' she said, pointing at the ground, and the lightning — genuinely embarrassed — grounded itself for a week. The machines still whisper about it in the walls. The kittens were unbothered. They were napping.",
  },
  {
    id: "lore-socket",
    unlockAt: 4,
    title: "SOCKET'S FIRST GATE",
    pal: "SOCKET",
    text: "The east gate of the settlement jammed shut during dinner — terrible timing, as stew was involved. The grown-ups argued for an hour. Socket, age small, walked up with a crayon, drew an X where it hurt, and tightened exactly one bolt. The gate has opened politely ever since. His invoice read: 'one (1) stew, extra crackers.' He has been the chief mechanic since Tuesday.",
  },
];

export const TRAIT_COLORS = {
  BRUTE: "#ff6a3d",
  SIGNAL: "#00c8ff",
  SCAVENGE: "#ffcf5c",
  CHARM: "#c77dff",
};

export const MISSIONS = [
  {
    id: "mine",
    name: "RUST MINE DELVE",
    trait: "BRUTE",
    seconds: 60,
    shards: [8, 14],
    xp: 20,
    desc: "Brute-force the collapsed rust mines for scrap-shards. Bring elbows, not manners.",
  },
  {
    id: "market",
    name: "SCRAP MARKET RUN",
    trait: "SCAVENGE",
    seconds: 90,
    shards: [12, 18],
    xp: 26,
    desc: "Haggle with the scrap barons of Dust Market. Every deal is a heist if you wink.",
  },
  {
    id: "tower",
    name: "GHOST TOWER INFILTRATION",
    trait: "CHARM",
    seconds: 120,
    shards: [15, 22],
    xp: 34,
    fragment: true,
    desc: "Sneak the dead broadcast tower. Matching titans bring back a LORE FRAGMENT.",
  },
  {
    id: "decrypt",
    name: "DEAD FREQUENCY DECRYPT",
    trait: "SIGNAL",
    seconds: 180,
    shards: [20, 30],
    xp: 44,
    desc: "Crack a dead frequency's vault. Only the signal-brained need apply.",
  },
];

// deterministic pseudo-random for procedural visuals (radar maze, silhouettes)
export const seededRand = (seed) => {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i += 1) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return () => {
    h ^= h << 13;
    h ^= h >>> 17;
    h ^= h << 5;
    return (h >>> 0) / 4294967295;
  };
};
